/* eslint-disable */
import React,{ Fragment, useEffect, useState } from "react";
import styles from "./CreateTemplate.module.css";
import TitleWithPathHeader from "../../General/TitleWithPathHeader/TitleWithPathHeader";
import PageContent from "../../General/PageContent/PageContent";
import { useAppSelector } from "../../../redux/store";

const Preview = (id) => {
    const [selectedImage,setSelectedImage] = useState();
    let jwt = useAppSelector((state) => state.authReducer.jwt);

    // const value="https://assets.preprod.ctdevops.com/assets/marketing-platform/emailTemplate/179714560756/Lexus_Template_July_R/images/Cancelled Paid Product-Lexus.png"
    useEffect(() => {
    if (id.templateId) {
       const getImageDetails = async () => {
        console.log(id.templateId)
        const url = new URL(
            `${process.env.REACT_APP_API_HOSTNAME}v1/template/${id.templateId}/image-previewurl`
          );
      
          const callParams = {
            method: "GET",
            headers: {
              "x-api-key": `${process.env.REACT_APP_API_KEY}`,
              "Content-Type": "application/json",
              Authorization: `Bearer ${jwt}`
            }
          };
          const serverResponse = await fetch(url.toString(), callParams);
          const serverResponseJson = serverResponse.json().then((response) => {
          const res = response;
          setSelectedImage(res.previewImageUrl)
        });
      };
      getImageDetails();
    }
  }, []);

  return (
    <Fragment>
     <TitleWithPathHeader
        title="Preview Template"
        path="/manage template/preview template"
      />
   
   <PageContent className={styles.CreateCampaign}>
    <div className={styles.BigSvg}>
    <img src={selectedImage?selectedImage:"No Image Found"} />
    </div>
    </PageContent>
    </Fragment>
  );
};

export default Preview;
